(function () {
  'use strict';

  var binderMobileQuery = window.matchMedia('(max-width: 991px)');
  var binderDrawerPanel = null;
  var binderDrawerPreviousFocus = null;
  var binderDrawerEventsReady = false;

  function binderDrawerIsOpen() {
    return !!(binderDrawerPanel && binderDrawerPanel.classList.contains('is-open'));
  }

  function syncBinderDrawerAccessibility() {
    var isOpen = binderDrawerIsOpen();

    document.querySelectorAll('[data-vmax-binder-filter-open]').forEach(function (button) {
      button.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    });

    if (!binderDrawerPanel) return;

    if (binderMobileQuery.matches) {
      binderDrawerPanel.setAttribute('role', 'dialog');
      binderDrawerPanel.setAttribute('aria-modal', 'true');
      binderDrawerPanel.setAttribute('aria-hidden', isOpen ? 'false' : 'true');
    } else {
      binderDrawerPanel.removeAttribute('role');
      binderDrawerPanel.removeAttribute('aria-modal');
      binderDrawerPanel.removeAttribute('aria-hidden');
    }
  }

  function closeBinderDrawer(restoreFocus) {
    if (!binderDrawerPanel) return;

    binderDrawerPanel.classList.remove('is-open');
    document.documentElement.classList.remove('vmax-binderpos-filter-drawer-open');
    document.body.classList.remove('vmax-binderpos-filter-drawer-open');
    syncBinderDrawerAccessibility();

    if (restoreFocus && binderDrawerPreviousFocus && typeof binderDrawerPreviousFocus.focus === 'function') {
      binderDrawerPreviousFocus.focus();
    }
  }

  function openBinderDrawer() {
    initializeBinderDrawer();
    if (!binderMobileQuery.matches || !binderDrawerPanel) return;

    binderDrawerPreviousFocus = document.activeElement;
    binderDrawerPanel.classList.add('is-open');
    document.documentElement.classList.add('vmax-binderpos-filter-drawer-open');
    document.body.classList.add('vmax-binderpos-filter-drawer-open');
    syncBinderDrawerAccessibility();

    var closeButton = binderDrawerPanel.querySelector('[data-vmax-binder-filter-close]');
    if (closeButton) {
      window.setTimeout(function () {
        closeButton.focus();
      }, 230);
    }
  }

  function trapBinderDrawerFocus(event) {
    if (!binderMobileQuery.matches || !binderDrawerIsOpen() || event.key !== 'Tab') return;

    var focusable = Array.prototype.filter.call(
      binderDrawerPanel.querySelectorAll('button:not([disabled]), [href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'),
      function (element) {
        return !element.hidden && element.offsetParent !== null;
      }
    );

    if (!focusable.length) return;

    var first = focusable[0];
    var last = focusable[focusable.length - 1];

    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  }

  function initializeBinderDrawerEvents() {
    if (binderDrawerEventsReady) return;
    binderDrawerEventsReady = true;

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && binderDrawerIsOpen()) {
        closeBinderDrawer(true);
        return;
      }

      trapBinderDrawerFocus(event);
    });

    var handleBreakpointChange = function () {
      if (!binderMobileQuery.matches) closeBinderDrawer(false);
      syncBinderDrawerAccessibility();
    };

    if (typeof binderMobileQuery.addEventListener === 'function') {
      binderMobileQuery.addEventListener('change', handleBreakpointChange);
    } else if (typeof binderMobileQuery.addListener === 'function') {
      binderMobileQuery.addListener(handleBreakpointChange);
    }
  }

  function initializeBinderDrawer() {
    initializeBinderDrawerEvents();

    document.querySelectorAll('[data-vmax-binder-filter-open]').forEach(function (button) {
      if (button.hasAttribute('data-vmax-binder-filter-ready')) return;
      button.setAttribute('data-vmax-binder-filter-ready', 'true');
      button.addEventListener('click', openBinderDrawer);
    });

    var panel = Array.prototype.find.call(document.querySelectorAll('.left-column.tag-filter'), function (candidate) {
      return (
        candidate.querySelector('select#game') &&
        candidate.querySelector('input#q') &&
        candidate.querySelector('select#availabilty')
      );
    });

    if (!panel) return;

    if (binderDrawerPanel && binderDrawerPanel !== panel) {
      closeBinderDrawer(false);
    }

    binderDrawerPanel = panel;
    binderDrawerPanel.id = 'VmaxBinderPosFilterDrawer';
    binderDrawerPanel.classList.add('vmax-binderpos-filter-drawer');

    var title = binderDrawerPanel.querySelector('.left-title');
    if (title && !title.querySelector('[data-vmax-binder-filter-close]')) {
      var closeButton = document.createElement('button');
      closeButton.className = 'vmax-binderpos-filter-drawer__close';
      closeButton.type = 'button';
      closeButton.setAttribute('aria-label', 'Fermer les filtres');
      closeButton.setAttribute('data-vmax-binder-filter-close', '');
      closeButton.innerHTML = '<span aria-hidden="true">&times;</span>';
      closeButton.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        closeBinderDrawer(true);
      });
      title.appendChild(closeButton);
    }

    syncBinderDrawerAccessibility();
  }

  function getBinderAvailabilitySelect() {
    return document.querySelector('.left-column.tag-filter select#availabilty');
  }

  function syncBinderStockToggle() {
    var stockToggle = document.querySelector('[data-vmax-binder-stock-toggle]');
    var availabilitySelect = getBinderAvailabilitySelect();

    if (!stockToggle) return;

    if (!availabilitySelect) {
      stockToggle.disabled = true;
      stockToggle.setAttribute('aria-pressed', 'false');
      stockToggle.classList.remove('is-active');
      return;
    }

    var inStockOnly = availabilitySelect.value === 'true';
    stockToggle.disabled = false;
    stockToggle.setAttribute('aria-pressed', inStockOnly ? 'true' : 'false');
    stockToggle.classList.toggle('is-active', inStockOnly);
  }

  function initializeBinderStockToggle() {
    var stockToggle = document.querySelector('[data-vmax-binder-stock-toggle]');
    var availabilitySelect = getBinderAvailabilitySelect();

    if (!stockToggle) return;

    if (!stockToggle.hasAttribute('data-vmax-binder-stock-toggle-ready')) {
      stockToggle.setAttribute('data-vmax-binder-stock-toggle-ready', 'true');
      stockToggle.addEventListener('click', function () {
        var currentAvailabilitySelect = getBinderAvailabilitySelect();
        if (!currentAvailabilitySelect) {
          syncBinderStockToggle();
          return;
        }

        currentAvailabilitySelect.value = currentAvailabilitySelect.value === 'true' ? 'false' : 'true';
        currentAvailabilitySelect.dispatchEvent(new Event('change', { bubbles: true }));
        syncBinderStockToggle();
      });
    }

    if (availabilitySelect && !availabilitySelect.hasAttribute('data-vmax-binder-stock-toggle-listener')) {
      availabilitySelect.setAttribute('data-vmax-binder-stock-toggle-listener', 'true');
      availabilitySelect.addEventListener('change', syncBinderStockToggle);
    }

    syncBinderStockToggle();
  }

  function replaceLeadingText(element, translation) {
    if (!element) return;

    var textNode = Array.prototype.find.call(element.childNodes, function (node) {
      return node.nodeType === 3 && node.nodeValue.trim().length > 0;
    });

    if (textNode && textNode.nodeValue.trim() !== translation) {
      textNode.nodeValue = translation;
    }
  }

  function replaceExactText(selector, translations) {
    document.querySelectorAll(selector).forEach(function (element) {
      var currentText = element.textContent.trim();
      if (translations[currentText]) {
        element.textContent = translations[currentText];
      }
    });
  }

  function ensureRarityFilterHelp() {
    var raritySelect = document.querySelector('.left-column.tag-filter select#rarities');
    if (!raritySelect) return;

    var select2 = raritySelect.nextElementSibling;
    if (!select2 || !select2.classList.contains('select2')) return;

    var helpId = 'VmaxBinderPosRarityHelp';
    var help = document.getElementById(helpId);

    if (!help) {
      help = document.createElement('small');
      help.id = helpId;
      help.className = 'vmax-binderpos-filter-help';
      help.setAttribute('data-vmax-binder-rarity-help', '');
      help.textContent = 'Tapez une rareté, puis sélectionnez une suggestion pour appliquer le filtre.';
      select2.insertAdjacentElement('afterend', help);
    }

    var searchInput = select2.querySelector('input.select2-search__field');
    if (!searchInput) return;

    var describedBy = (searchInput.getAttribute('aria-describedby') || '').split(/\s+/).filter(Boolean);
    if (describedBy.indexOf(helpId) === -1) {
      describedBy.push(helpId);
      searchInput.setAttribute('aria-describedby', describedBy.join(' '));
    }
  }

  function translateBinderPosInterface() {
    var collection = document.querySelector('[data-vmax-binderpos-collection]');
    if (!collection) return;

    initializeBinderDrawer();
    initializeBinderStockToggle();

    if (document.querySelector('.left-column.tag-filter')) {
      document.documentElement.classList.add('vmax-binderpos-filters-ready');
    }

    var products = collection.querySelector('.products-display');
    if (products && /^Error loading products\./i.test(products.textContent.trim())) {
      products.textContent = '';

      var error = document.createElement('div');
      error.className = 'vmax-binderpos-collection__notice';

      var errorMessage = document.createElement('p');
      errorMessage.textContent = 'Impossible de charger les filtres pour le moment. Vous pouvez continuer à parcourir la collection sans filtres.';

      var fallbackLink = document.createElement('a');
      fallbackLink.className = 'btn';
      fallbackLink.href = collection.getAttribute('data-native-url');
      fallbackLink.textContent = 'Afficher la collection sans filtres';

      error.appendChild(errorMessage);
      error.appendChild(fallbackLink);
      products.appendChild(error);
    }

    var labels = {
      game: 'Catégorie',
      q: 'Nom de la carte',
      availabilty: 'Disponibilité',
      condition: 'État',
      priceMin: 'Prix minimum',
      priceMax: 'Prix maximum',
      printing: 'Finition / édition',
      setNames: 'Série',
      rarities: 'Rareté',
      types: 'Type',
      colors: 'Couleur',
      monsterTypes: 'Type de monstre'
    };

    Object.keys(labels).forEach(function (id) {
      replaceLeadingText(document.querySelector('label#' + id), labels[id]);
    });

    var generatedLabels = {
      Category: 'Catégorie',
      'Search Name': 'Nom de la carte',
      Availabilty: 'Disponibilité',
      Condition: 'État',
      'Min Price': 'Prix minimum',
      'Max Price': 'Prix maximum',
      'Printing/Edition': 'Finition / édition',
      Sets: 'Série',
      Rarities: 'Rareté',
      Types: 'Type',
      Colors: 'Couleur',
      'Monster Type': 'Type de monstre'
    };

    document.querySelectorAll('.left-column.tag-filter label').forEach(function (label) {
      var leadingText = Array.prototype.find.call(label.childNodes, function (node) {
        return node.nodeType === 3 && node.nodeValue.trim().length > 0;
      });

      if (leadingText && generatedLabels[leadingText.nodeValue.trim()]) {
        leadingText.nodeValue = generatedLabels[leadingText.nodeValue.trim()];
      }
    });

    replaceExactText('.sidebar-title, .block-heading', {
      FILTER: 'FILTRE',
      FILTRER: 'FILTRE'
    });

    replaceExactText('#availabilty option, .select2-selection__rendered', {
      'Instock Only': 'En stock seulement',
      'All Singles': 'Toutes les cartes'
    });

    var placeholders = {
      'search by name': 'Rechercher par nom',
      'browse any condition': 'Tous les états',
      'browse all printing/editions': 'Toutes les finitions / éditions',
      'browse all sets': 'Toutes les séries',
      'browse all rarities': 'Tapez, puis sélectionnez une rareté',
      'browse all types': 'Tous les types',
      'browse all colors': 'Toutes les couleurs',
      'browse all monster type': 'Tous les types de monstre'
    };

    document.querySelectorAll('input[placeholder]').forEach(function (input) {
      var placeholder = input.getAttribute('placeholder');
      var translatedPlaceholder = placeholder && placeholders[placeholder.toLowerCase()];
      if (translatedPlaceholder) {
        input.setAttribute('placeholder', translatedPlaceholder);
      }
    });

    ensureRarityFilterHelp();

    var count = document.querySelector('.filters-toolbar__product-count');
    if (count) {
      var match = count.textContent.trim().match(/^Showing\s+(\d+)\s+-\s+(\d+)$/i);
      if (match) {
        count.textContent = 'Produits ' + match[1] + ' à ' + match[2];
      }
    }

    replaceExactText('.icon__fallback-text, .product-block-hover .value, .outstock-overlay', {
      Prev: 'Précédent',
      Next: 'Suivant',
      'Select Options': 'Choisir les options',
      'SOLD OUT': 'ÉPUISÉ'
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    if (!document.querySelector('[data-vmax-binderpos-collection]')) return;

    var translationQueued = false;
    var observer = new MutationObserver(function () {
      if (translationQueued) return;
      translationQueued = true;

      window.requestAnimationFrame(function () {
        translationQueued = false;
        translateBinderPosInterface();
      });
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });

    translateBinderPosInterface();
  });
})();
